import services from "../services";
import * as types from "./mutation-type";

export const setPriceProduct = ({ commit }, payload) => {
  commit(types.SET_PRICE_PRODUCT, payload)
}

export const setQuantityFractional = ({ commit }, payload) => {
  commit(types.SET_QUANTITY_FRACTIONAL, payload)
}

export const setMinimumQuantityFractional = ({ commit }, payload) => {
  commit(types.SET_MINIMUM_QUANTITY_FRACTIONAL, payload)
}

export const ActionGetProduct = async ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.get(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}

export const getAdditionalItems = async ({_}, payload) => {
  return new Promise(async(resolve, reject) => {
      const { data } = await services.getAdditionalItems(payload)
      if(data.error === false) {
          resolve(data)
      }
      reject(data)
  })
}

export const setResetItemsGrid = ({ commit }, payload) => {
  commit(types.SET_RESET_ITEMS_GRID, payload)
}

export const setNumberOfBoxesSelected = ({ commit }, payload) => {
  commit(types.SET_NUMBER_OF_BOXES_SELECTED, payload)
}

export const setConversionUnitWhenSellingWithClosedBox = ({ commit }, payload) => {
  commit(types.SET_CONVERSION_UNIT_WHEN_SELLING_WITH_CLOSED_BOX, payload)
}

export const ActionSetMinimumQuantity = ({ commit }, payload) => {
  commit(types.SET_MINIMUM_QUANTITY, payload)
}

export const setQuantityProductItemsGroup = ({ commit }, payload) => {
  commit(types.SET_QUANTITY_PRODUCT_ITEMS_GROUP, payload)
}

// PRODUCT
export const setResetProduct = ({ commit }, payload) => {
  commit(types.SET_RESET_PRODUCT, payload)
}

export const setBkpProduct = ({ commit }, payload) => {
  commit(types.SET_BKP_PRODUCT, payload)
}

export const ActionSetProductPriceToBkpDiscountClosedBox = ({ commit }, payload) => {
  commit(types.SET_PRODUCT_PRICE_TO_BKP_DISCOUNT_CLOSED_BOX, payload);
}

// ADDITIONAL ITEMS
export const setAdditionalItems = ({ commit }, payload) => {
  commit(types.SET_ADDITIONAL_ITEMS, payload)
}

export const setAdditionalItemsSelected = ({ commit }, payload) => {
  commit(types.SET_ADDITIONAL_ITEMS_SELECTED, payload)
}

export const ActionResetAdditionalItems = ({ commit }, payload) => {
  commit(types.RESET_ADDITIONAL_ITEMS, payload)
}

// VARIATIONS
export const setVariations = ({ commit }, payload) => {
  commit(types.SET_VARIATIONS, payload)
}

export const resetActiveVariations = ({ commit }, payload) => {
  commit(types.RESET_ACTIVE_VARIATIONS, payload)
}

export const ActionSetItemByVariation = ({ commit }, payload) => {
  commit(types.SET_ITEM_BY_VARIATION, payload)
}

export const ActionSetItem = ({ state, commit, dispatch }, payload) => {
    dispatch('getItemsGridOrganized', payload)
    if(payload?.tie_sale_products instanceof Array) {
      payload?.tie_sale_products?.map(el => {
        if(el instanceof Object) {
          dispatch('getItemsGridOrganized', el)
        }
      })
    }
    commit(types.SET_ITEM, payload)
    commit(types.SET_BKP_PRODUCT, JSON.parse(JSON.stringify(payload)))

    commit(types.SET_MINIMUM_QUANTITY, payload)
    commit(types.SET_FLAVORS, payload.flavors ?? [])
    commit(types.SET_VARIATIONS, payload.linked_products ?? [])
    commit(types.SET_PRODUCT_PRICE_TO_BKP_DISCOUNT_CLOSED_BOX, payload.price_to)
    commit(types.SET_PRODUCT_PRO_PRICE_SITE_BKP_DISCOUNT_CLOSED_BOX, payload.pro_price_site)
    commit(types.SET_SETTINGS, JSON.parse(payload.settings))
    if (payload.fractional_sale) {
      commit(types.SET_MINIMUM_QUANTITY_FRACTIONAL, payload)
      commit(types.SET_QUANTITY_FRACTIONAL, state.minimumQuantityFractional)
    }
}
// Seta a quantidade a ser comprada
export const setQuantity = ({ commit }, payload) => {
  commit(types.SET_QUANTITY, payload)
}

export const setAvailability = ({ commit }, payload) => {
  commit(types.SET_AVAILABILITY, payload)
}

export const ActionSetItemWish = ({ commit }, payload) => {
    commit(types.SET_ITEM_WISH, payload)
}

export const ActionResetCarouselModal = ({_}, payload) => {
  const sliderDefaultOptions = {
    loop: true,
    margin: 0,
    responsiveClass: true,
    nav: true,
    navText: ['<i class="icon-angle-left">', '<i class="icon-angle-right">'],
    dots: false,
    autoplay: true,
    touchDrag:true,
    autoplayTimeout: 8000,
    items: 1,
  }
  jQuery('.'+payload).owlCarousel(sliderDefaultOptions)
  .on('changed.owl.carousel', function() {
    var $source = jQuery(this);
      $source.find('img').each(function () {
        var $this = jQuery(this),
        zoomConfig = {
          responsive: true,
          zoomWindowFadeIn: 352,
          zoomWindowFadeOut: 200,
          borderSize: 0,
          zoomContainer: $this.parent(),
          zoomType: 'inner',
          cursor: 'grab'
        }
        $this.elevateZoom(zoomConfig)
    })
  })
  jQuery('#carousel-custom-dots-modal .owl-dot').click(function () {
      jQuery('.'+payload).trigger('to.owl.carousel', [jQuery(this).index(), 300])
  })
}

export const ActionResetCarousel = ({_}, payload) => {
  const sliderDefaultOptions = {
    loop: true,
    margin: 0,
    responsiveClass: true,
    nav: true,
    navText: ['<i class="icon-angle-left">', '<i class="icon-angle-right">'],
    dots: false,
    autoplay: true,
    touchDrag:true,
    autoplayTimeout: 8000,
    items: 1,
  }
  jQuery('.'+payload).owlCarousel(sliderDefaultOptions)
  .on('changed.owl.carousel', function() {
    var $source = jQuery(this);
      $source.find('img').each(function () {
        var $this = jQuery(this),
        zoomConfig = {
          responsive: true,
          zoomWindowFadeIn: 352,
          zoomWindowFadeOut: 200,
          borderSize: 0,
          zoomContainer: $this.parent(),
          zoomType: 'inner',
          cursor: 'grab'
        }
        $this.elevateZoom(zoomConfig)
    })
  })
  jQuery('#carousel-custom-dots .owl-dot').click(function () {
      jQuery('.'+payload).trigger('to.owl.carousel', [jQuery(this).index(), 300])
  })
  // Gallery Lightbox
  var links = [];
  var $productSliderImages = $('.product-single-carousel .owl-item:not(.cloned) img').length === 0 ? $('.product-single-gallery img') : $('.product-single-carousel .owl-item:not(.cloned) img');
  $productSliderImages.each(function () {
    links.push({ 'src': $(this).attr('data-zoom-image') });
  });

  $(".prod-full-screen").click(function (e) {
    var currentIndex;
    if (e.currentTarget.closest(".product-slider-container")) {
      currentIndex = ($('.product-single-carousel').data('owl.carousel').current() + $productSliderImages.length - Math.ceil($productSliderImages.length / 2)) % $productSliderImages.length;
    }
    else {
      currentIndex = $(e.currentTarget).closest(".product-item").index();
    }

    $.magnificPopup.open({
      items: links,
      navigateByImgClick: true,
      type: 'image',
      gallery: {
        enabled: true
      },
    }, currentIndex);
  });
}

export const ActionPersistRating = ({_}, payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await services.persistRating(payload)
      if(!data?.error) {
          resolve(data)
      }
      reject(data)
    } catch(error) {
      reject(error.response.data)
    }
  })
}

export const getItemsGridOrganized = ({_}, payload) => {
    payload.items_grid_columns_and_rows = new Object({column: {}, row: {}})
    let items_grid_columns_and_rows = {column: {}, row: {}}
    let columnWithoutGrid = [];
    payload?.items_grid?.forEach(item => {
        if(item.group_option_column_id && !item.group_option_row_id) {
            services.organizeItemsGridByColumn(items_grid_columns_and_rows, item)
        } else if(!item.group_option_column_id && item.group_option_row_id) {
            services.organizeItemsGridByRow(items_grid_columns_and_rows, item)
        }else if (item.group_option_column_id && item.group_option_row_id) {
            services.organizeItemsGridByColumnAndRow(items_grid_columns_and_rows, item)
        } else {
            services.organizeItemsGridWithoutGrid(columnWithoutGrid, item)
        }
    });
    if(!jQuery.isEmptyObject(items_grid_columns_and_rows.column)  || !jQuery.isEmptyObject(items_grid_columns_and_rows.row)) {
        services.setColumnInRowAndRowInColumn(payload?.items_grid, items_grid_columns_and_rows)
        payload.items_grid_columns_and_rows.column = Object.values(items_grid_columns_and_rows.column)
        payload.items_grid_columns_and_rows.row = Object.values(items_grid_columns_and_rows.row)
        return;
    }
    payload.items_grid_columns_and_rows.column = columnWithoutGrid
}
